import { useState, useEffect } from "react";
import * as React from "react";
import { graphql, PageProps, useStaticQuery } from "gatsby";
import HeaderFooter from "@layouts/header-footer";
import Clients from "@components/home/clients";
import { display, h1, p, pl, stats } from "@components/ui/typography/typography.module.css";
import Services from "@components/services/migration-services";
import ClientSliderCta from "@components/cta/clients-slider";
import LabelTitleDescription from "@layouts/label-title-description";
import Section from "@layouts/section";
import TextLabel from "@components/ui/text-label";
// import RorMigrate from "@components/services/benefits/ror-migrate";
import TechStack from "@components/services/tech-stack";
import Testimonails from "@components/testimonials";
import Faqs, { FaqQueryResultTypes } from "@components/faqs";
import CaseStudies from "@components/case-studies";
import ServicespageCta from "@components/cta/services-page-cta";
import CtaSupportText from "@components/cta-support-text";
import MigratePhpToRailsGuide from "@components/cta/migrate-php-to-rails";
import LottieAnimation from "@/components/lottie";
import ScheduleButton from "@components/ui/schedule-button";
import AnimationRoRmigrationServicesDesktop from "@animations/ror-migration-services/ror-migration-services-desktop.json";
import AnimationRoRmigrationServicesMobile from "@animations/ror-migration-services/ror-migration-services-mobile.json";
import { container } from "@styles/common-styles.module.css";
import { Helmet } from "react-helmet";
import Button from "@/components/ui/button";
import Modal from "@components/ui/modal";
import ContactForm from "@components/contact/contact-form";

interface RorMigration {
  heroTitle: string;
  heroDescription: string;
  heroCtaBtn: string;
  heroBtnHintText: string;
  ourServiceLabel: string;
  ourServiceTitle: string;
  ourServiceMainDescriptionOne: string;
  clientSliderTitle: string;
  clientSliderCtaText: string;
  benefitsLabel: string;
  benefitsTitle: string;
  techStackLabel: string;
  techStackTitle: string;
  inNumberLabel: string;
  inNumbersTitle: string;
  inNumbersStatOne: string;
  inNumbersDescriptionOne: string;
  inNumbersStatTwo: string;
  inNumbersDescriptionTwo: string;
  inNumbersStatThree: string;
  inNumbersDescriptionThree: string;
  inNumbersStatFour: string;
  inNumbersDescriptionFour: string;
  testimonialLabel: string;
  testimonialTitle: string;
  faqLabel: string;
  faqTitle: string;
  caseStudiesLabel: string;
  caseStudiesTitle: string;
  ctaTitle: string;
  ctaDescription: string;
  ctaBtnText: string;
  faqSubTitle: string;
  faqBtnText: string;
  ctaBtnTextHint: string;
  seo: {
    seoTitle: string;
    seoDescription: string;
  };
}

interface RorMigrationServicePage {
  allStrapiRorMigrationServicePage: {
    nodes: RorMigration[];
  };
}
const RorMigrationPage: React.FC<PageProps> = () => {
  const data: FaqQueryResultTypes & RorMigrationServicePage = useStaticQuery(graphql`
    query RorMigrationPage {
      allStrapiFaq(filter: { faq_tags: { elemMatch: { tag: { eq: "ror-migration" } } } }) {
        nodes {
          question
          answer {
            data {
              answer
            }
          }
          faq_tags {
            tag
          }
        }
      }
      allStrapiRorMigrationServicePage {
        nodes {
          heroTitle
          heroDescription
          heroCtaBtn
          heroBtnHintText
          ourServiceLabel
          ourServiceTitle
          ourServiceMainDescriptionOne
          clientSliderTitle
          clientSliderCtaText
          benefitsLabel
          benefitsTitle
          techStackLabel
          techStackTitle
          inNumberLabel
          inNumbersTitle
          inNumbersStatOne
          inNumbersDescriptionOne
          inNumbersStatTwo
          inNumbersDescriptionTwo
          inNumbersStatThree
          inNumbersDescriptionThree
          inNumbersStatFour
          inNumbersDescriptionFour
          testimonialLabel
          testimonialTitle
          faqLabel
          faqTitle
          caseStudiesLabel
          caseStudiesTitle
          ctaTitle
          ctaDescription
          ctaBtnText
          faqSubTitle
          faqBtnText
          ctaBtnTextHint
          seo {
            seoTitle
            seoDescription
          }
        }
      }
    }
  `);
  const query = data.allStrapiRorMigrationServicePage.nodes;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(!isModalOpen);
  const [canonicalUrl, setCanonicalUrl] = useState("");
  useEffect(() => {
    if (typeof window !== "undefined") {
      setCanonicalUrl(window.location.href);
    }
  }, []);
  return (
    <>
      {query.map((seoData) => (
        <Helmet>
          <title>{seoData.seo.seoTitle}</title>
          <link rel="canonical" href={canonicalUrl} />
          <meta name="description" content={seoData.seo.seoDescription} />
        </Helmet>
      ))}

      <HeaderFooter>
        {query.map((result) => (
          <>
            <section className="pt-8">
              <div className="md:hidden">
                <LottieAnimation animationData={AnimationRoRmigrationServicesMobile} />
              </div>
              <div className="relative -mx-6">
                <LottieAnimation
                  animationData={AnimationRoRmigrationServicesDesktop}
                  className="hidden absolute z-[-1] mx-auto md:flex inset-x-0"
                />
              </div>
              <div className={`${container}`}>
                <div className={`w-full max-w-3xl mt-8 md:mt-20 ror-migration-hero-section`}>
                  <h1 className={display}>{result.heroTitle}</h1>
                  <p className={`${pl} pl mt-6 md:mt-8 max-w-2xl relative `}>
                    {result.heroDescription}
                  </p>
                  <div className="mt-8 md:mt-10 flex flex-col md:flex-row md:gap-6">
                    <ScheduleButton variant="primary">{result.heroCtaBtn}</ScheduleButton>

                    <Button
                      variant="outline"
                      className="block w-full mt-6 md:mt-0 md:inline-block md:w-auto"
                      size="lg"
                      onClick={openModal}
                    >
                      Write us
                    </Button>
                  </div>
                  <CtaSupportText>{result.heroBtnHintText}</CtaSupportText>
                </div>
              </div>
                <Modal open={isModalOpen} closeModal={() => setIsModalOpen(false)}>
                  <ContactForm callBack={() => setIsModalOpen(false)} />
                </Modal>
            </section>
            <section className={`${container} mt-12 md:mt-60`}>
              <Clients />
            </section>
            <Section>
              <LabelTitleDescription label={result.ourServiceLabel} title={result.ourServiceTitle}>
                <div className="md:px-6">
                  <p className={`${pl} mt-6 md:mt-0`}>{result.ourServiceMainDescriptionOne}</p>
                </div>
              </LabelTitleDescription>
              <Services />
            </Section>
            <ClientSliderCta
              title={result.clientSliderTitle}
              ctaText={result.clientSliderCtaText}
            />
            {/* <Section>
            <TextLabel>{result.benefitsLabel}</TextLabel>
            <h3 className={`${h1} mt-6`}>{result.benefitsTitle}</h3>
            <RorMigrate className="mt-20" />
          </Section>  */}
            <MigratePhpToRailsGuide />
            <Section>
              <TextLabel>{result.techStackLabel}</TextLabel>
              <h3 className={`${h1} mt-6`}>{result.techStackTitle}</h3>
              <TechStack className="mt-16" />
            </Section>
            <Section>
              <TextLabel>{result.inNumberLabel}</TextLabel>
              <h3 className={`${h1} mt-6`}>{result.inNumbersTitle}</h3>
              <div className="flex flex-col md:flex-row mt-16 gap-8">
                <div className="flex md:w-1/3 flex-col">
                  <p className={stats}>{result.inNumbersStatOne}</p>
                  <hr className="h-[2px] bg-dark mt-4" />
                  <p className={`${p} mt-4`}>{result.inNumbersDescriptionOne}</p>
                </div>
                <div className="flex md:w-1/3 flex-col">
                  <p className={stats}>{result.inNumbersStatTwo}</p>
                  <hr className="h-[2px] bg-dark mt-4" />
                  <p className={`${p} mt-4`}>{result.inNumbersDescriptionTwo}</p>
                </div>
                <div className="flex md:w-1/3 flex-col">
                  <p className={stats}>{result.inNumbersStatThree}</p>
                  <hr className="h-[2px] bg-dark mt-4" />
                  <p className={`${p} mt-4`}>{result.inNumbersDescriptionThree}</p>
                </div>
                <div className="flex md:w-1/3 flex-col">
                  <p className={stats}>{result.inNumbersStatFour}</p>
                  <hr className="h-[2px] bg-dark mt-4" />
                  <p className={`${p} mt-4`}>{result.inNumbersDescriptionFour}</p>
                </div>
              </div>
            </Section>
            <Testimonails label={result.testimonialLabel} title={result.testimonialTitle} />
            <Faqs
              label={result.faqLabel}
              title={result.faqTitle}
              data={data.allStrapiFaq.nodes}
              subTitle={result.faqSubTitle}
              btnText={result.faqBtnText}
              heading="h3"
            />
            {/* <CaseStudies label={result.caseStudiesLabel} title={result.caseStudiesTitle} /> */}
            <ServicespageCta
              title={result.ctaTitle}
              description={result.ctaDescription}
              ctaBtn={result.ctaBtnText}
              ctaHint={result.ctaBtnTextHint}
              handleClick={() => {}}
              heading="h3"
            />
          </>
        ))}
      </HeaderFooter>
    </>
  );
};

export default RorMigrationPage;
